import type { ReactNode } from "react";
import { Chakra } from "@airhelp/react-ui-components";

const { Box } = Chakra;

const ScrollWrapper = ({ children }: { children: ReactNode }) => (
  <Box overflowX="auto" my={{ base: 8, lg: 14 }}>
    {children}
  </Box>
);

export default ScrollWrapper;
